module.exports = __webpack_public_path__ + "img/Qc.542f980a.png";